import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: "center", padding: "1.2vw", marginTop: "70px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p>
          {t("homePage.supportText")}{" "}
          <a href="mailto:support@cm.smobilpay.com" >
            support@cm.smobilpay.com
          </a>
        </p>
      </div>
      <p style={{ marginTop: "30px" }}>
        Powered by
        <img
          src="https://p-smobilpay-public-resources.s3.dualstack.eu-central-1.amazonaws.com/prl/maviance-logo.png"
          alt="Logo"
          style={{ paddingLeft: 5, width: "150px" }}
        />
      </p>
    </div>
  );
};

export default Footer;
